import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterModule } from '@commons/footer/footer.module';
import { LogoModule } from '@commons/logo/logo.module';
import { SvgIconModule } from '@commons/svg-icon/svg-icon.module';
import { TrackerModule } from '@commons/tracker/tracker.module';
import { ListSkeletonModule } from '@domains/jobs/list-skeleton/list-skeleton.module';
import { ListModule } from '@domains/jobs/list/list.module';
import { HomeRoutingModule } from '@features/home/home-routing.module';
import { ScrollContentItemDirective } from '@features/home/home/directives/scroll-content-item.directive';
import { ScrollMenuItemDirective } from '@features/home/home/directives/scroll-menu-item.directive';
import { HomeComponent } from '@features/home/home/home.component';
import { LinkProtocolPipe } from '@features/home/home/pipes/link-protocol.pipe';
import { NgxsModule } from '@ngxs/store';
import { JobsState } from '@store/jobs/jobs.state';
import { WizPipesModule } from '@wizbii/angular-utilities';
import { ScrollToModule } from '@wizbii/nicky-lenaers_ngx-scroll-to';
import { HeadDescriptionModule, HeadTitleModule } from '@wizbii/seo-lib';

@NgModule({
  declarations: [HomeComponent, ScrollMenuItemDirective, ScrollContentItemDirective, LinkProtocolPipe],
  imports: [
    CommonModule,
    HomeRoutingModule,
    NgxsModule.forFeature([JobsState]),
    LogoModule,
    SvgIconModule,
    ScrollToModule,
    ListModule,
    ListSkeletonModule,
    WizPipesModule,
    FooterModule,
    HeadTitleModule,
    HeadDescriptionModule,
    TrackerModule,
  ],
})
export class HomeModule {}
